import { render, staticRenderFns } from "./ObkDescriptionIdNoteStep.vue?vue&type=template&id=642b55bc&scoped=true"
import script from "./ObkDescriptionIdNoteStep.vue?vue&type=script&lang=js"
export * from "./ObkDescriptionIdNoteStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642b55bc",
  null
  
)

export default component.exports